import { Component, OnInit, OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { DoctorsService } from '../../../../services/doctors.service';
import { DoctorBreadcrumbService } from '../../shared/breadcrumb.service';
import { AppointmentService } from "../../../../services/appointment.service";
import { Router, NavigationEnd } from '@angular/router';
import { PromiseResult, ErrorModel, ServerError } from '../../../../models/PromiseResult';
import { HttpErrorResponse } from '@angular/common/http';
import { appointmentGetQuery } from "../../../../models/appointment";
import { AppointmentZoom } from "../../../../models/appointment";
import { ConfirmationService, MessageService } from 'primeng';
import { GenrateToken } from 'src/app/models/patient-profile';
import { PatientProfileService } from 'src/app/services/patient-profile.service';
import { SendProfileLinkService } from 'src/app/services/send-profile-link.service';
import { ROLES, URLS, USER_TYPES } from 'src/app/constant/constant';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { ICard } from 'src/app/models/idcard';
import { Title } from "@angular/platform-browser";
import { DateUtilService, moment_duration } from '../../../../utilities/date.util.service';
import { TraceClassDecorator } from '@sentry/angular';
import { ProviderStateService } from 'src/app/services/provider-state.service';
import { TokenService } from 'src/app/utilities/token.service';
import { GraphqlService } from 'src/app/services/graphql.service';
import { FetchProviderLicenses } from 'src/app/models/provider';
import { ProviderService } from 'src/app/services/provider.service';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';
import { filter } from 'rxjs/operators';
import { LanguageService } from 'src/app/services/language.service'; // Import LanguageService

interface appointments {
    id: number,
    reqno: string,
    // date_requested: string,
    patientUrl: string,
    patientName: string,
    // mrn: string,
    age: string,
    // opinion_type: string,
    // priority: string,
    speciality: string[],
    communication_type: string,
    // documents: string,
    // country: string,
    // state: string,
    // city: string,
    doctor: string[],
    status: string,
    patient_guid: string,
    doctor_user_guid: string[],
    consultation_date: Date,
    consultation_id: number,
    appointments_id: number,
    current_user_guid: string,

}

@TraceClassDecorator()
@Component({
    selector: 'app-doctor-home',
    templateUrl: './doctor-home.component.html',
    styleUrls: [
        '../../../../../assets/css/custom-egd.css',
        './doctor-home.component.css',
    ],
    providers: [
        MessageService,
        ConfirmationService,
    ],
})

export class DoctorHomeComponent implements OnInit, OnDestroy {

    readonly userTypes = USER_TYPES;
    is_primary_provider: boolean;
    is_uk_country: boolean = false;
    providerLicensesData: FetchProviderLicenses[] = [];
    selected_patient_guid: string;
    selected_doctor_user_guid: string;
    selected_consultation_id: number;
    currentStatus: string;
    login_role: any;
    share_loader: boolean;
    share_dialog: boolean;
    join_zoom_url_for_attendee: any;
    has_trial_completed: boolean = false;
    patient_profile_link: string = "";

    zoom_query: AppointmentZoom = {
        patient_guid: null,
        consultation_id: null,
    }

    message: string = "";

    doctor_userid: string;
    response: PromiseResult;
    error: ErrorModel;
    serverError: ServerError;
    posting: boolean;
    displaycard: boolean;
    loading: boolean;

    doctorICard: ICard;

    loading1: boolean = true;

    doctor_user_id: string;

    my_appointment_Get_Query: appointmentGetQuery;

    my_patients: appointments[] = [];

    initateLoader: boolean = false;

    initate_response: PromiseResult;
    initate_error: ErrorModel;
    initate_serverError: ServerError;
    is_superadmin: boolean = false;
    join_zoom = "";
    dcount: number = 0;
    ucount: number = 0;
    total_number_of_users: number = 0;
    total_number_of_doctors: number = 0;
    base_url: string = "";
    edit_url: string = "";
    logo_url: string = "";
    slug: string = "";
    is_doctor: boolean = false;
    checklistData: any = {};

    languageOptions: { code: string, name: string }[] = [
        { code: 'en', name: 'English' },
    { code: 'hi', name: 'Hindi' },
    { code: 'fr', name: 'French' },
    { code: 'ar', name: 'Arabic'},
    { code: 'es', name: 'Spanish' },
    { code: 'pt', name: 'Portuguese' },
    { code: 'de', name: 'German' },
    { code: 'mr', name: 'Marathi' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'te', name: 'Telugu' },
    { code: 'ta', name: 'Tamil' },
    { code: 'bn', name: 'Bengali' },
    { code: 'ur', name: 'Urdu' },
    { code: 'pa', name: 'Punjabi' },
    { code: 'kn', name: 'Kannada' },
    { code: 'or', name: 'Oriya' },
    { code: 'ne', name: 'Nepali' }
    ];

    selectedLanguage: string = 'en'; // Default language

    navigationSubscription: Subscription;

    constructor(
        private readonly doctorsService: DoctorsService,
        private readonly router: Router,
        private readonly appointmentService: AppointmentService,
        private readonly breadcrumbService: DoctorBreadcrumbService,
        private readonly messageService: MessageService,
        private readonly patientProfileService: PatientProfileService,
        private readonly shareLink: SendProfileLinkService,
        private readonly titleService: Title,
        private readonly utitilitiesService: UtilitiesService,
        private readonly dateUtil: DateUtilService,
        private readonly providerstateService: ProviderStateService,
        private readonly tokenUtil: TokenService,
        private readonly graphqlService: GraphqlService,
        private readonly providerService: ProviderService,
        private readonly translateService: GoogleTranslateService,
        private readonly renderer: Renderer2,
        private readonly languageService: LanguageService,
        // Inject LanguageService
    ) {


        this.base_url = this.utitilitiesService.getBaseUserURL(this.router.url, 2)
        this.edit_url = "/" + this.base_url + "/edit";
    }



    async ngOnInit() {
        this.initateLoader = false;
        this.slug = this.providerstateService.getProviderSlug();
        this.is_primary_provider = this.providerstateService.getIsPrimaryProvider();
        if(URLS.IS_UK)
        {
            this.is_uk_country = true;
        }
        this.breadcrumbService.setItems([
            { label: 'Dashboard', },
        ]);
        this.login_role = this.tokenUtil.findRoleId();



        await this.getProviderLicenses(true);
        console.log("function")
        this.logo_url = this.providerstateService.getLogoUrl();
        this.titleService.setTitle("Dashboard - Doctor Dashboard");
        this.doctor_user_id = sessionStorage.getItem('userid');
        this.loading = true;
        this.loading1 = true;
        this.doctorICard = {
            first_name: "",
            middle_name: "",
            last_name: "",
            date_of_birth: "",
            avatar_url: "",

            doctor_profile: {
                doctor_number: 0,
                is_active: true,
                speciality: {
                    specialty_name: "",
                }
            },
            country: {
                country_name: "",
                acronym: "",
            },
            role_type: {
                id: null,
                title: "",
            },
            other_medical_profile: {
                is_active: null,
                other_medical_id: null,
                primary_occupation: "",
            },
        }
        this.my_appointment_Get_Query = {
            user_guid: this.doctor_user_id,
            self: true,
            fromtime: null,
            totime: null,
        };
        this.posting = false;
        await this.ResetResultModels();
        this.doctor_userid = sessionStorage.getItem('userid');
        await this.getIDCardData();
        await this.getMyAppointments();
        this.loading = false;
        this.loading1 = false;
        await this.getChecklist();
        this.getCounts();

        this.navigationSubscription = this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(async () => {
                await this.ResetResultModels();
                await this.getIDCardData();
                await this.getMyAppointments();
                this.initializeLanguage();
            });

        this.initializeLanguage();

    }

    async getCounts() {
        this.graphqlService.getAllCounts().subscribe(
            (result) => {
                this.dcount = result.data['countDoctors'];
                this.ucount = result.data['aggregateUsers'][0]['totalCountOfUsers'];

            },
            (error) => {
                console.error('There was an error fetching the count from the API', error);
            }
        );
    }

    async translatePage(event: Event) {
        const selectedLangCode = (event.target as HTMLSelectElement).value;
        this.selectedLanguage = selectedLangCode; // Update selected language
        localStorage.setItem('selectedLanguageClient', selectedLangCode); // Save to localStorage
        this.translateService.setGoogleTranslateLanguage(selectedLangCode);
        this.languageService.setLanguage(selectedLangCode);

        // Update notranslate class based on the selected language
        if (selectedLangCode === 'en') {
            document.body.classList.add('notranslate');
        } else {
            document.body.classList.remove('notranslate');
        }
    }

    initializeLanguage() {
        const savedLanguage = localStorage.getItem('selectedLanguageClient') || 'en';
        this.selectedLanguage = savedLanguage;
        this.translateService.setGoogleTranslateLanguage(savedLanguage);

        // Update notranslate class based on the saved language
        if (savedLanguage === 'en') {
            document.body.classList.add('notranslate');
        } else {
            document.body.classList.remove('notranslate');
        }
    }



    private async ResetResultModels(): Promise<void> {

        this.response = {
            success: null,
            error: null,
            data: null
        };
        this.serverError = {
            statusCode: null,
            error: null,
            message: null
        }
    }
    private async ResetResultInitateModels(): Promise<void> {

        this.initate_response = {
            success: null,
            error: null,
            data: null
        };
        this.initate_serverError = {
            statusCode: null,
            error: null,
            message: null
        }
    }

    async getIDCardData() {
        await this.ResetResultModels();
        this.loading = true;
        await this.doctorsService.getDoctorIDCardData(this.doctor_userid).toPromise()
            .then(result => {

                this.response = result;
                if (this.response.success) {
                    this.doctorICard = result.data;
                    this.loading = false;
                }
                else if (!this.response.success) {
                    if (result.data != null &&
                        result.data.has_agreed != null &&
                        !result.data.has_agreed
                    ) {
                        return this.router.navigate(['/doctor/agreement']);
                    }
                    this.error = result.error;
                    this.loading = false;
                }

                this.posting = false;
            }).catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                this.loading = false;
            });
    }

    editProfile() {
        this.posting = true;
        this.RouterNavigation(this.edit_url);
    }

    showcardDialog() {
        this.posting = true;
        this.displaycard = true;
        this.posting = false;

    }
    close() {
        this.displaycard = false;
    }

    async getMyAppointments() {
        await this.ResetResultModels();
        this.loading1 = true;
        let fromDate = new Date().toISOString();
        let temp = new Date();
        temp.setDate(new Date().getDate() + 7);
        let toDate = temp.toISOString();
        this.my_appointment_Get_Query = {
            user_guid: this.doctor_user_id,
            self: true,
            fromtime: new Date(fromDate),
            totime: new Date(toDate),
        };

        await this.appointmentService.GetAllMyAssignedPatients(this.my_appointment_Get_Query).toPromise().then(result => {

            this.response = result;
            if (this.response.success) {
                let temp: appointments[] = [];
                for (let i = 0; i < result.data.length; i++) {
                    let my_appointments_obj: appointments = {
                        id: i + 1,
                        reqno: result.data[i].consultation_request_number,
                        // date_requested: result.data[i].created_at,
                        patientUrl: result.data[i].accounts.avatar_url,
                        patientName: result.data[i].accounts.first_name + " " + (result.data[i].accounts.middle_name == null ? '' : result.data[i].accounts.middle_name) + " " + result.data[i].accounts.last_name,
                        // mrn: result.data[i].accounts.medical_record_number,
                        age: this.dateUtil.diff(result.data[i].accounts.date_of_birth, new Date(), moment_duration.years) + ' Yrs',
                        // opinion_type: result.data[i].priority_type.consultation_name,
                        // priority: result.data[i].priority_type.priority_type,
                        speciality: result.data[i].p_consultation_appointment.map(d => {
                            return d.d_specialty_type.specialty_name
                        }),
                        communication_type: result.data[i].communication_type.communication_name,
                        // documents: 'www.google.com',
                        // country: result.data[i].accounts.country.country_name,
                        // state: result.data[i].accounts.state_name,
                        // city: result.data[i].accounts.city,
                        doctor: result.data[i].p_consultation_appointment.map(d => {
                            return d.egd_users.first_name + ' ' + d.egd_users.last_name
                        }),
                        status: result.data[i].consultation_status,
                        patient_guid: result.data[i].patient_guid,
                        consultation_date: result.data[i].consultation_date,
                        doctor_user_guid: result.data[i].p_consultation_appointment.map(d => {
                            return d.user_guid
                        }),
                        consultation_id: Number(result.data[i].id),
                        appointments_id: (result.data[i].p_appointments != null) ? Number(result.data[i].p_appointments.id) : null,
                        current_user_guid: this.doctor_user_id,
                    }
                    temp.push(my_appointments_obj)
                }
                this.my_patients = temp;

            }
            else if (!this.response.success) {
                this.error = result.error;
            }
            this.loading1 = false;
        }).catch((error: HttpErrorResponse) => {
            this.serverError = error.error;
            this.response.success = false;
            this.loading1 = false;
        });

    }

    async open_zoom(patient_guid: string, consultation_id: number) {
        await this.ResetResultInitateModels();
        this.initateLoader = true;
        let data: AppointmentZoom = { patient_guid: patient_guid, consultation_id: consultation_id };
        await this.appointmentService.ZoomAppointmentUrl(this.doctor_user_id, data)
            .toPromise()
            .then(async result => {

                this.initate_response = result;
                if (this.initate_response.success) {
                    this.join_zoom = result.data.start_url;
                    this.initateLoader = false;
                    if (this.join_zoom?.length > 0) {
                        window.open(this.join_zoom, '_blank');
                    }
                }
                else if (!this.initate_response.success) {
                    this.error = result.error;
                }
                this.initateLoader = false;
            }).catch((error: HttpErrorResponse) => {
                this.initate_serverError = error.error;
                this.initate_response.success = false;
                this.initateLoader = false;
            });

    }

    async open_initate(doctor_user_guid: string, patient_guid: string, consultation_id: number, status: string) {
        this.selected_patient_guid = patient_guid;
        this.selected_doctor_user_guid = doctor_user_guid;
        this.selected_consultation_id = consultation_id;
        this.currentStatus = status;
        // this.iniateDialog = true;
        await this.RouterNavigation("/doctor/appointments/patient-view/" + patient_guid + "/" + consultation_id);

    }

    async open_share(consultation_id: number, patient_guid: string) {
        this.message = "";
        this.share_loader = true;
        await this.ResetResultModels();
        this.zoom_query = {
            patient_guid: patient_guid,
            consultation_id: consultation_id
        };
        await this.appointmentService.ZoomAppointmentUrl(this.doctor_user_id, this.zoom_query)
            .toPromise()
            .then(async result => {
                this.response = result;

                if (result.success) {
                    this.join_zoom_url_for_attendee = result.data.join_url;
                    // this.patient_profile_link=this.base+"/"+"doctor/patientProfile/"+patient_guid+"/"+consultation_id;

                    this.message = this.join_zoom_url_for_attendee;
                    // this.initate_response = result;
                    // if (this.initate_response.success) {
                    //     this.join_zoom = result.data.start_url;
                    //     this.initateLoader = false;
                    //     if (this.join_zoom?.length > 0) {
                    //         window.open(this.join_zoom, '_blank');
                    //     }
                    // }
                    // else if (!this.initate_response.success) {
                    //     this.error = result.error;
                    // }
                    // this.initateLoader = false;
                }
            }).catch((error: HttpErrorResponse) => {
                this.serverError = error.error;
                this.response.success = false;
                // this.initateLoader = false;
            });
        this.share_dialog = true;
        this.share_loader = false;
    }

    closeShareDialog() {
        this.share_dialog = false;
    }

    closeShare(closeDialog) {
        if ((Boolean(closeDialog))) {
            this.messageService.add({
                severity: "success",
                summary: "Success",
                detail: "Your message has been sent",
            });
        }
        this.share_dialog = !(Boolean(closeDialog));
    }

    RouterNavigation(path: string) {
        this.router.navigate(["/" + this.slug + '/' + path]);
    }

    async getToken(user_guid: string) {
        if (user_guid) {
            await this.ResetResultModels();
            let temp = new Date();
            temp.setDate(new Date().getDate() + 35);
            let validTillDate = temp;
            let data_queryGenrateToken: GenrateToken = {
                user_guid: user_guid,
                patient_guid: this.zoom_query.patient_guid,
                valid_till: validTillDate
            }
            await this.patientProfileService.GenrateToken(data_queryGenrateToken)
                .toPromise()
                .then(result => {
                    this.response = result;
                    if (result.success) {
                        // this.join_zoom_url_for_attendee=result.data.join_url;
                        this.patient_profile_link = result.data.link
                        this.shareLink.setProfileLink(this.patient_profile_link);

                    }
                }).catch(error => console.log(error));
        }
    }

    async getChecklist() {
        await this.providerService.Checklist().toPromise().then(result => {

            this.checklistData = result.data;
        }).catch(error => console.log(error))
    }

    async getProviderLicenses(isActive?: Boolean) {
        if (this.login_role == 3 || this.login_role == 4) {
            this.is_superadmin = true;
        }
        if (this.login_role == 1 || this.login_role == 4 || this.login_role == 5) {
            this.is_doctor = true;
        }
        else {
            this.is_doctor = false;
        }

        this.graphqlService.fetchProviderLicenses(isActive).subscribe(
            (result) => {
                this.providerLicensesData = result.data['fetchProviderLicenses']['providerLicense'];
                console.log('Provider Licenses Data:', this.providerLicensesData);
                this.has_trial_completed = result.data['has_trial_completed'];
                console.log(this.has_trial_completed, "chedk")
                if (this.providerLicensesData.length > 0) {
                    this.total_number_of_doctors = result.data['fetchProviderLicenses']['providerLicense'][0]['number_of_users'];
                    this.total_number_of_users = result.data['fetchProviderLicenses']['providerLicense'][0]['number_of_patients'];

                }
            },
            (error) => {
                console.error('There was an error fetching the provider licenses from the API', error);
            }
        );
    }

    gotoPlans() {
        this.RouterNavigation("/doctor/license_plans")
    }

    gotoDreg() {
        this.RouterNavigation("/doctor/dregistration")
    }

    gotoCountry() {
        this.RouterNavigation("/doctor/provider-countries")
    }

    gotoSpeciality() {
        this.RouterNavigation("/doctor/departments")
    }

    gotoLogo() {
        this.RouterNavigation("/doctor/update-logo")
    }

    gotoStripe() {
        this.RouterNavigation("/doctor/api_keys")
    }

    ngOnDestroy() {
        if (this.navigationSubscription) {
            this.navigationSubscription.unsubscribe();
        }
    }

}
